import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UserAppFeatureMatrix} from '@models/api/user/user-app-feature.matrix';
import {FileDownloaderService} from '@services/file-downloader.service';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ApiUserService {

    constructor(
        private httpClient: HttpClient,
        private fileDownloaderService: FileDownloaderService,
    ) {
    }

    /**
     * Get user avatar
     * @param firstName
     * @param lastName
     */
    public getAvatar(firstName: string, lastName: string): Observable<string> {
        return this.fileDownloaderService
            .downloadDataAsBase64(`${environment.BaseApiUrl}/User/Avatar?firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}`);
    }

    public getAppFeatureMatrix(): Observable<UserAppFeatureMatrix> {
        return this.httpClient
            .get<UserAppFeatureMatrix>(`${environment.BaseApiUrl}/User/AppFeatureMatrix`);
    }

}
